import {
    MACHINE_NUMBER_PERMISSIONS,
    STOCK_NUMBER_PERMISSIONS,
} from '../constants/bucket.contants'
import { Permission, Roles } from '../constants/roles.constants'

export const getPermission = (role: any) => {
    let permission: string[] = []
    
    if (role == Roles.APP_ADMIN) {
        permission = [
            Permission.CAN_EDIT_USERS,
            Permission.ALLOW_ALL_FEATURES,
            Permission.CAN_EDIT_BUCKET,
        ]
    }
    if (role == Roles.BUSINESS_ENTITY_ADMIN) {
        permission = [
            Permission.CAN_EDIT_USERS,
            Permission.ALLOW_ALL_FEATURES,
            Permission.CAN_EDIT_BUCKET,
        ]
    }

    if (role == Roles.APP_USER) {
        permission = [Permission.ALLOW_ALL_FEATURES, Permission.CAN_EDIT_BUCKET]
    }

    if (role == Roles.GUEST) {
        permission = [Permission.READ_ONLY]
    }

    return permission
}

export const isDisabled = (permission: string[], item: any) => {
    if (
        !permission?.includes(Permission.CAN_EDIT_BUCKET) &&
        (item == STOCK_NUMBER_PERMISSIONS || item == MACHINE_NUMBER_PERMISSIONS)
    ) {
        return true
    } else {
        return false
    }
}

export const isReadOnly = (permission: string[]) => {
    return permission.includes(Permission.READ_ONLY)
}
